// extracted by extract-css-chunks-webpack-plugin
module.exports = {"text":"L3MPZ1","lineThrough":"_3YIU_B","inChronicle":"_2awbNd","accent":"fvO9ph","obviously":"y7pdnF"};